// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3By8e","title":"styles_title__1E2ck"};